import { PAYMENT_METHODS } from './interfaces';

export const apiMethodMapper = (method: PAYMENT_METHODS): string => {
  switch (method) {
    case PAYMENT_METHODS.EXTERNAL_BANK_TRANSFER_ACCESS:
      return `External Bank Transfer`;
    default:
      return '';
  }
};
